import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { Color } from '../../../assets/color';
import RouteHeader from '../../../components/common/RouteHeader';
import DatatableHeading from '../../../components/heading/DatatableHeading';
import DatatableWithSearch from '../../../components/datatable/DatatableWithSearch';
import * as SuperadminActions from '../../../redux/actions/superadminAction';

const Customers = () => {
    const dispatch = useDispatch();
    const { customersAllData } = useSelector(state => state?.superadminReducer);

    // Sort ascending by createdAt (oldest first, latest at bottom)
    const sortedData = customersAllData
        ? [...customersAllData].sort((a, b) => new Date(b?.createdAt) - new Date(a?.createdAt))
        : [];

    //* Datatable Columns
    const columns = [
        { name: 'S.No.', selector: (row, index) => index + 1, width: '70px', sortable: false },
        {
            name: 'Date & Time',
            selector: row => row?.createdAt ? new Date(row.createdAt).toLocaleString('en-IN', {
                day: '2-digit', month: 'short', year: 'numeric',
                hour: '2-digit', minute: '2-digit', hour12: true
            }) : '—',
            width: '180px',
            sortable: true,
            sortFunction: (a, b) => new Date(a?.createdAt) - new Date(b?.createdAt),
        },
        { name: 'Admin', selector: row => row?.admin_name || '—', width: '140px', sortable: true },
        { name: 'Partner Name', selector: row => row?.partner_name || '—', width: '160px', sortable: true },
        { name: 'Partner ID', selector: row => row?.partner_registration_number || '—', width: '140px', sortable: true },
        { name: 'Affiliate', selector: row => row?.affiliate_name || '—', width: '160px', sortable: true },
        { name: 'Customer Name', selector: row => row?.full_name || '—', width: '180px', sortable: true },
        { name: 'Mobile No.', selector: row => row?.mobile_number || '—', width: '140px' },
        { name: 'Email', selector: row => row?.email || '—', width: '230px' },
        { name: 'City', selector: row => `${row?.city || ''}${row?.country ? ', ' + row.country : ''}`, width: '160px' },
        { name: 'Age Group', selector: row => row?.age_group || (row?.age ? `${row.age} yrs` : '—'), width: '120px' },
        { name: 'Gender', selector: row => row?.gender || '—', width: '100px' },
        { name: 'Report Type', selector: row => row?.report_type || '—', width: '200px' },
        {
            name: 'Status',
            cell: row => (
                <span style={{
                    padding: '4px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '600',
                    backgroundColor: row?.payment_status === 'Paid' ? '#e6f4ea' : row?.payment_status === 'Pending' ? '#fff8e1' : '#fce8e6',
                    color: row?.payment_status === 'Paid' ? '#1e7e34' : row?.payment_status === 'Pending' ? '#f57f17' : '#c62828',
                }}>
                    {row?.payment_status || '...'}
                </span>
            ),
            width: '120px',
        }
    ];

    useEffect(() => {
        dispatch(SuperadminActions.getCustomersAll());
    }, []);

    return (
        <>
            <RouteHeader title={`Customers MIS`} sub_title={`Manage and view customers information`} />
            <div style={{ backgroundColor: Color.white, padding: '20px', borderRadius: '10px' }}>
                <Grid container spacing={6}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <DatatableHeading title={'Customers Management Information System'} sub_title={`Total ${sortedData?.length || 0} report generations. Each entry represents one report generated.`} />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <DatatableWithSearch data={sortedData} columns={columns} pagination={true} />
                    </Grid>
                </Grid>
            </div>
        </>
    );
};

export default Customers;
